import React from 'react';
import Report from "../../../../../core/model2/report/report";

type Props = {
    report          : Report
    onSelectReport    : callback
}

export default function ModalReportSelect_ReportPreview(props: Props) {

    const onClick = () => {
        props.onSelectReport(props.report)
    }

    const classes = "flex-row-left-top cursor-default w-275 h-100 p-l-30 p-r-30 p-t-30 p-b-20 m-r-10"

    return (
        <div className = {Classes(classes)}
             onClick   = {onClick}>
            <div className="min-w-35">
                <div className={Classes(props.report.icon, "w-100-percent", "h-35", "ui5-ico-18", "m-r-10")}></div>
            </div>
            <div className="m-l-25">
                <div className="ui5-txt-default m-b-8">
                    {props.report.name}
                </div>
                <div className="ui5-txt-not-important-tiny lh-14em">
                    {props.report.description}
                </div>
            </div>
        </div>
    );
}
